<template>
  <div>
    <template v-if="!fromSaas">
      <!-- logo -->
      <div class="shunda_logo" v-if="isSdLogin">
        <img :src="`${$ossUrl}image/logo/shunda_logo.png`" alt="">
      </div>
      <div class="hebeisaosu_logo" v-else-if="isHbgsLogin">
        <img :src="`${$ossUrl}image/logo/hebeigaosu_logo.png`" alt="">
      </div>
      <div class="logo" v-else>
        <img :src="`${$ossUrl}image/logo/sidebar-logo.png`" alt="">
        <div></div>
        <span>团油商家版</span>
      </div>
    </template>
    <!-- menu -->
    <el-menu
      :default-active="activeMenu"
      :text-color="variables.menuText"
      :active-text-color="variables.menuActiveText"
    >
      <sideBar-item v-for="route in routes" v-show="route.meta.type === menuType" :key="route.path" :item="route" :base-path="route.path" :fromSaas="fromSaas" @toLink="item => $emit('toLink', item)"></sideBar-item>
    </el-menu>
  </div>
</template>
<script>
import SideBarItem from './SidebarItem'
import Variables from '@/styles/variables.less'
import { mapGetters, mapState } from 'vuex'
export default {
  name: 'sideBar',
  components: {
    SideBarItem
  },
  data () {
    return {
      // isSdLogin: false
    }
  },
  props: ['active'],
  computed: {
    ...mapState({
      fromSaas: state => state.user.fromSaas
    }),
    ...mapGetters([
      'routes',
      'menuType',
      'isSdLogin',
      'isHbgsLogin'
    ]),
    activeMenu () {
      if (this.active) {
        return this.active
      }
      const route = this.$route
      const { meta, path } = route
      // if set path, the sidebar will highlight the path you set
      if (meta.activeMenu) {                                                  
        return meta.activeMenu
      }
      return path
    },
    variables () {
      return Variables
    }
  },
  mounted() {
    // this.isSdLogin = JSON.parse(sessionStorage.getItem('isSdLogin'))
  },
}
</script>
<style lang="less" scoped>
  .shunda_logo img {
    width: 200px;
  }
  
  .hebeisaosu_logo{
    display: flex;
    margin: 22px 0;
    justify-content: center;
    img{
     width: 158px;
     display: block;
    }
  } 
</style>
